<template>
  <div class="common-layout">
    <!-- <div class="header-layout"> -->
      <!-- 政务服务网的logo -->
      <!-- <zwfw-logo class="zwfw-logo" /> -->
      <!-- <search /> -->
    <!-- </div> -->
    <Header2 />
    <div class="banner">
      <div class="login-button-box">
        <p class="login-subtitle">浙江省金融综合服务平台</p>
        <p id="login-title">浙里金融</p>
        <button class="login-button" @click="handlePersonLogin">个人用户登录</button>
        <button class="login-button" @click="handlelegalLogin">法人用户登录</button>
      </div>
    </div>
    <!-- <FooterLogin /> -->
  </div>
</template>

<script>
// import ZwfwLogo from '@/components/ZwfwwLogo'
// import FooterLogin from '@/components/FooterLogin'
// import search from './components/search'
import Header2 from '@/components/Header/index'
import { getZjzwfwLegalLoginUrlSplice, getZjzwfwPersonLoginUrlSplice } from '@/config/index'
import { mapState } from 'vuex'
export default {
  components: {
    // ZwfwLogo,
    // FooterLogin,
    // search
    Header2
  },
  mounted() {
    if ((this.ticket || this.token) && !this.isTokenExpire) {
      this.$router.push('/')
    }
  },
  methods: {
    handlePersonLogin() {
      this.$store.commit('user/CLEAN_USER_INFO')
      window.location.href = getZjzwfwPersonLoginUrlSplice()
    },
    handlelegalLogin() {
      this.$store.commit('user/CLEAN_USER_INFO')
      window.location.href = getZjzwfwLegalLoginUrlSplice()
    }
  },
  computed: {
    ...mapState('user', ['ticket', 'token', 'isTokenExpire'])
  }
}
</script>

<style lang="scss" scoped>
.common-layout {
  box-sizing: border-box;
  background: rgba(247, 247, 247, 1);

  /deep/ .header-info {
    display: none;
  }
}
// .header-layout {
//   height: 110px;
//   background: white;
//   display: flex;
//   @include text-24-400;
// }
.zwfw-logo {
  flex: 1;
}
.login-subtitle {
  font-size: 20px;
  color: #fff;
  letter-spacing: 1px;
}
.banner {
  width: 100%;
  height: 593px;
  padding-top: 20px;
  background: url('../../assets/images/login-bg.jpg') center no-repeat;
  position: relative;
  .login-button-box {
    position: absolute;
    right: 360px;
    top: 156px;
    width: 300px;
    @include displayCenter($align-items: flex-start);
    flex-flow: column;
    #login-title {
      @include text-36-600;
      color: rgba(255, 255, 255, 1);
      line-height: 71px;
      margin-bottom: 51px;
    }
    .login-button {
      width: 300px;
      height: 50px;
      cursor: pointer;
      background: rgba(41, 84, 208, 1);
      border-radius: 4px;
      border: 0px;
      color: white;
      @include text-18-300;
      margin-bottom: 41px;
    }
  }
}
</style>
